$(document).ready(function() {
  
  	//localStorage['is_shown']='no';
  
  	if((window.location.pathname=='/collections/avid')&&(localStorage['is_shown']=='no')){
    	$('#myModal').modal({ backdrop: false });
      	localStorage['is_shown']='yes';
  	}
        
   
   
   
   
//     $('ul.tabs').each(function(){
//       var active, content, links = $(this).find('a');
//       active = links.first().addClass('active_sound_tab');
//       content = $(active.attr('href'));
//       links.not(':first').each(function () {
//         $($(this).attr('href')).hide();
//       });
//       $(this).find('a').click(function(e){
//         active.removeClass('active_sound_tab');
//         content.hide();
//         active = $(this);
//         content = $($(this).attr('href'));
//         active.addClass('active_sound_tab');
//         content.show();
//         return false;
//       });
//     });
   $('#search form').submit(function( event ) {
     
     
      $('#search form input[type=text]').val($('#search form input[type=text]').val()+' AND -product_type:sound');
    });
   
   
   $('#searchaudio').submit(function( event ) {
     
      var words = $('#searchaudio input[type=text]').val().split(" ");
      var search_string = '';
      var i;
      for (i = 0; i < words.length; ++i) {
        if(words[i].length>0){
          if(i > 0){
            search_string += ' OR ';
          }
          search_string += 'title:'+words[i]+' OR tag:'+words[i];
        }
      }
     
      $('#searchaudio input[type=text]').val(search_string +' AND product_type:sound');
    });
   
   $('.down_href').click(function( event ) {
//       var href = $(this).data('href');
//       window.location.href = href;
      var a = $(this);

      if(typeof a.download != "undefined")
      {
         // download attribute is supported
      }
      else
      {
        // download attribute is not supported
      }
    });
   
      
   
   $('.search').submit(function( event ) {
//      event.preventDefault();
     var str =$('.search input[type=text]').val();
//      alert(str);
//      if (str.indexOf(' AND -product_type:sound') == -1 && str!="") {
//              $('.search input[type=text]').val($('.search input[type=text]').val()+' AND -product_type:sound');
//      }
    });
   
   	var tid = setInterval(mycode, 1800000);
    function mycode() {
      localStorage.removeItem('visited');
//       localStorage.clear();
    }
   
   	var a = location.pathname.split("/");
	if ( a.length > 2 && a[2] == "avid" ) { 
     		var yetVisited = localStorage['visited']; 
            if (!yetVisited) {
                 $('#myModal').modal({
                    backdrop: false
                  });
                localStorage['visited'] = "yes";
            }
        }
   
   	
   
    function reposition() {
        var modal = $(this),
        dialog = modal.find('.modal-dialog');
        modal.css('display', 'block');
        dialog.css("margin-top", Math.max(0, ($(window).height() - dialog.height()) / 2));
    }
   
    
   var modal = $(this),
   dialog = modal.find('.modal-dialog');
   modal.css('display', 'block');
   dialog.css("margin-top", Math.max(0, ($(window).height() - dialog.height()) / 2));
   
    // Reposition when a modal is shown
    $('.modal').on('show.bs.modal', reposition);
    // Reposition when the window is resized
    $(window).on('resize', function() {
        $('.modal:visible').each(reposition);
    });
    
   $('#customer_login').submit(function( event ) {
//      event.preventDefault();
   		localStorage.removeItem('visited');
   });
});

    document.addEventListener('play', function(e){
        var audios = document.getElementsByTagName('audio');
        for(var i = 0, len = audios.length; i < len;i++){
            if(audios[i] != e.target){
                audios[i].pause();
            }
        }
    }, true);

    function song_play(id) {
      var audio = document.getElementById(id);
      elements = document.getElementsByClassName("play_sound");
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.backgroundColor="#ed5023";
            elements[i].style.display =  "";
        }
      elements = document.getElementsByClassName("pause_sound");
        for (var i = 0; i < elements.length; i++) {        
            elements[i].style.display =  "none";
        }
      document.getElementById("play_"+id).style.display =  "none";
      document.getElementById("pause_"+id).style.display =  "";
      document.getElementById("pause_"+id).style.background =  "black";

      audio.play();
    };

    function song_pause(id) {
      var audio = document.getElementById(id);
      document.getElementById("play_"+id).style.display =  "";
      document.getElementById("pause_"+id).style.display =  "none";
      document.getElementById("play_"+id).style.background =  "#ed5023";
      audio.pause();
    };

    function restart_song(id) {
        var audio =document.getElementById(id);
            audio.pause();
            audio.currentTime = 0
     };

